<!-- eslint-disable vue/html-indent -->
<template>
  <div style="margin: 0 20px; height: calc(100% - 55px)">
    <div>
      <div class="list_header">
        <div style="display: flex; align-items: center;">
          <i class="el-icon-arrow-left go_icon" @click="checkdetail1" style="cursor: pointer;" />
          <div class="list_header_" style="margin-left: 24px">
            <span class="list_heade_line">考核周期: </span>
            <span style="font-size: 16px; color: #333">{{detailInfos.meritsDate}}</span>
          </div>
          <div class="list_header_" v-if="detailInfos.realityScore">
            <span class="list_heade_line">综合得分: </span>
            <span
              style="font-size: 16px; color: #ff0000"
              v-if="detailInfos.realityScore"
            >{{detailInfos.realityScore}}</span>
            <span v-else>-</span>
            <span v-if="type !== 'tome'">
              <span v-if="type === 'examine'">
                <span v-if="dialogModifiedScore.scoreTableData && dialogModifiedScore.scoreTableData.length > 0">
                  <el-tooltip class="item" effect="dark" content="总分调整" placement="bottom">
                    <i class="iconfont icon-chaoshishoujiatiaozheng" style="padding-left: 10px;color: #2878ff;" @click="changeScore(detailInfos)" />
                  </el-tooltip>
                </span>
              <el-tooltip class="item" effect="dark" content="总分调整" placement="bottom" v-else>
                <i class="iconfont icon-chaoshishoujiatiaozheng" style="padding-left: 10px;" @click="changeScore(detailInfos)" />
              </el-tooltip>
              </span>
              <span v-if="type === 'me' || type === 'fromme '">
                <el-tooltip class="item" effect="dark" content="总分调整" placement="bottom" v-if="dialogModifiedScore.scoreTableData && dialogModifiedScore.scoreTableData.length > 0">
                    <i class="iconfont icon-chaoshishoujiatiaozheng" style="padding-left: 10px;color: #2878ff;" @click="changeScore(detailInfos)" />
                  </el-tooltip>
              </span>
            </span>
          </div>
          <div
            v-if="detailInfos.gradeName"
            class="list_header_"
            style="
            padding: 5px 12px;
            border-radius: 4px;
          "
          >
            <!--  background: rgba(40, 120, 255, 0.1); -->
            <span class="list_heade_line">评分等级: </span>
            <span
              style="font-size: 16px"
            >
              <span style="padding-right: 5px" :style="`color: ${detailInfos.gradeColor}`">{{detailInfos.gradeName}}</span>
              <span style="color: #999999" v-if="detailInfos.gradeRemark">({{detailInfos.gradeRemark}})</span>
            </span>
          <!-- <span v-else>-</span> -->
          </div>
          <div class="list_header_" v-if="detailInfos.meritsUserModel">
            <span class="list_heade_line">考核人: </span>
            <span style="font-size: 15px" v-if="channel === 'ding'">{{detailInfos.meritsUserModel.name}}</span>
            <span v-if="channel === 'wechat'" style="font-size: 15px">
              <ww-open-data
                type="userName"
                :openid="detailInfos.meritsUserModel.name"
              />
            </span>
          </div>
        </div>
        <div>
          <!-- v-if="channel === 'ding'" -->
          <el-button plain @click="exportMeri">
            <span>导出明细</span>
          </el-button>
          <el-button
            plain
            type="primary"
            @click.stop="submitInfo"
            v-if="detailInfos.submitFlag"
          >
            <span>提交</span>
          </el-button>
        </div>
      </div>
      <div style="height: 96%">
        <w-loading text="加载中.." :mask="true" :click="true" ref="loading" />
        <div class="table-box" style="height:calc(100vh - 250px)">
          <el-table
            :data="tableData"
            :header-cell-style="{
              background: '#F1F1F1 ',
              fontSize: '14px',
              color: '#999999',
            }"
            :span-method="objectSpanMethod"
            :cell-class-name="getCellClassName"
            style="width: 100%"
            border
            :cell-style="{
              fontSize: '14px'
            }"
            ref="table"
            height="100%"
          >
            <el-table-column fixed prop="typeName" label="考核分类" width="100" text-align="center">
              <template slot-scope="scope">
                <div style="width: 100%;text-align: center;">{{scope.row.typeName}}</div>
                <div style="width: 100%;text-align: center;">{{scope.row.typeScore}}%</div>
              </template>
            </el-table-column>
            <el-table-column fixed prop="content" label="考核内容" min-width="200">
              <template slot-scope="scope">
                <div>{{scope.row.content}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="分值" width="60">
              <template slot-scope="scope">
                <div v-if="scope.row.type === '0'">
                  {{scope.row.taskNormalScore}}
                </div>
                <div v-else>{{scope.row.score}}</div>
              </template>
            </el-table-column>

            <el-table-column
              v-for="(header, index) in tableHeaders"
              :key="index"
              :prop="header.prop"
              min-width="200"
            >
              <template v-slot:header>
                <span v-html="header.label">{{header.label}}</span>
              </template>
              <!-- 内容 -->
              <template slot-scope="scope">
                <div v-if="scope.row.extendValue[header.prop] || scope.row.extendValue[header.prop] === 0" v-html="getFormattedValue(scope.row.extendValue[header.prop])" />
                <div v-if="scope.row.extendValue[header.prop + '_file'] && scope.row.extendValue[header.prop + '_file'].length > 0">
                  <div
                    v-for="(item, index1) in scope.row.extendValue[header.prop + '_file']"
                    :key="index1"
                    @click.stop="previewFile(item)"
                    style="padding: 5px 0;cursor: pointer;display: flex;align-items: center;"
                  >
                    <i class="iconfont icon-wenjian file__icon" />
                    <el-tooltip
                      effect="dark"
                      :content="item.fileName"
                      placement="bottom"
                      popper-class="texttooltip"
                      :open-delay="500"
                    >
                      <span
                        style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 140px;display: inline-block;"
                      >{{item.fileName}}</span>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="score"
              :label="getScoreTypeLabel(detailInfos)"
              width="100"
              v-if="detailInfos.submitFlag && detailInfos.status !== '1'"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.extendEdit && !scope.row.extendEdit.editFlag"
                >
                  <span
                    v-if="
                      scope.row.type === '0' && scope.row.extendEdit.type == '0'
                    "
                  >{{scope.row.extendEdit.flowScore}}</span>
                  <span v-else>{{scope.row.extendEdit.flowScore}}</span>
                </div>
                <div v-else>
                  <div
                    v-if="
                      scope.row.type === '0' && scope.row.extendEdit.type == '0'
                    "
                  >
                    <el-input
                      type="text"
                      min="0"
                      max="200"
                      :placeholder="getScoreTypePlaceholder(detailInfos)"
                      @input="handleInput1($event, scope.row)"
                      @blur="changeText(scope.row, scope.$index)"
                      style="width: 100%;height: 110px;"
                      v-model="scope.row.extendEdit.flowScore"
                    />
                  </div>
                  <div v-else>
                    <el-input
                      type="text"
                      min="0"
                      max="200"
                      :placeholder="getScoreTypePlaceholder(detailInfos)"
                      @input="handleInput2($event, scope.row)"

                      @blur="changeText(scope.row, scope.$index)"
                      style="width: 100%;height: 110px;"
                      v-model="scope.row.extendEdit.flowScore"
                    />
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="scoreRemark"
              label="评分说明"
              width="200"
              v-if="detailInfos.submitFlag && detailInfos.status !== '1'"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.extendEdit && !scope.row.extendEdit.editFlag"
                >
                  {{scope.row.extendEdit.remark}}
                </div>
                <div v-else class="describe" @click="handleFocus(scope.row, scope.$index)">
                  <el-input
                    type="textarea"
                    maxlength="2000"
                    placeholder="请输入"
                    @blur="changeText(scope.row, scope.$index)"
                    @focus="handleFocus(scope.row, scope.$index)"
                    style="width: 100%;"
                    :style="{ height: getInputHeight(scope.row.extendEdit.fileList.length) }"
                    v-model="scope.row.extendEdit.remark"
                  />
                  <div class="file_lists" :style="{ height: getListtHeight(scope.row.extendEdit.fileList.length) }">
                    <!-- scope.row.extendEdit. -->
                    <div class="file_boxs" v-for="(item,index) in scope.row.extendEdit.fileList" :key="index">
                      <div class="file_text" @click.stop="previewFile(item, index)" style="width: 100%;display: flex;align-items: center;">
                        <i class="iconfont icon-wenjian file__icon" />
                        <el-tooltip
                          effect="dark"
                          :content="item.fileName"
                          placement="bottom"
                          popper-class="texttooltip"
                          :open-delay="500"
                        >
                          <span
                            style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 110px;display: inline-block;"
                          >{{item.fileName}}</span>
                        </el-tooltip>
                      </div>
                      <span>
                        <i class="iconfont icon-shanchu1 del__icon" @click.stop="delFun(item, index, scope.$index)" />
                      </span>
                    </div>
                  </div>
                  <div class="upload" v-if="uploadType === 'ding'" @click="uploadFile">
                    <div class="uploadfile">
                      <i class="iconfont icon-shangchuan file_icon" />
                    </div>
                  </div>
                  <div class="upload" v-if="uploadType === 'oss'">
                    <div class="uploadfile">
                      <multi-upload
                        :file-data="fileData"
                        @setFileList="successFile"
                        :upload-btn="uploadBtn"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="score"
              label="考核分"
              width="100"
              v-if="detailInfos.status === '1'"
            >
              <template #header>
                考核分
                <el-tooltip class="item" effect="dark" content="(分类得分项合计 * 评分占比 / 分类分值总计) * 分类占比 = 分类考核分" placement="bottom">
                  <i class="iconfont icon-shuoming progress_icon" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div>
                  <span>{{scope.row.totalTypeScore}}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 修改分数 -->
    <Dialogs :dialogs="dialogModifiedScore" @dialogVisible="beforeClose">
      <template #desc>
        <div v-if="dialogModifiedScore.scoreTableData && dialogModifiedScore.scoreTableData.length > 0" style="height:calc(100vh - 630px); overflow: auto;" class="info_subject">
              <el-table
                class="append_table"
                :data="dialogModifiedScore.scoreTableData"
                :header-cell-style="{
                  background: '#F1F1F1 ',
                  fontSize: '14px',
                  color: '#999999',
                }"
                style="height: 100%;overflow: auto;"
                border
              >
              <el-table-column prop="type" label="类型">
                  <template slot-scope="scope">
                  <div v-if="!scope.row.id" class="score_input">
                    <el-select
              ref="input_authType"
              v-model="scoreValue.type"
              placeholder="查看权限"
              @change="blurChange(scope.row)"
              style="width:80px"
            >
              <el-option
                v-for="item in scoreValue.scoreType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
                  </div>
                  <div v-else>
                    <div v-if="scope.row.type === '+'">加分</div>
                    <div v-if="scope.row.type === '-'">减分</div>
                  </div>
              </template>
            </el-table-column>
                <el-table-column prop="score" label="分值">
                  <template slot-scope="scope">
                  <div v-if="!scope.row.id" class="score_input">
                    <el-input v-model="scoreValue.num" placeholder="请输入分值" type="Number" />
                  </div>
                  <div v-else>{{scope.row.score}}</div>
              </template>
            </el-table-column>
                <el-table-column prop="desc" label="说明">
                  <template slot-scope="scope">
                    <div v-if="!scope.row.id" class="score_input">
                      <el-input v-model="scoreValue.content" placeholder="请输入说明" type="textarea" />
                    </div>
                <div v-else>{{scope.row.content}}</div>
              </template>
                </el-table-column>
                <el-table-column prop="createByUser" label="操作人">
                  <template slot-scope="scope">
                <div v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.createByUser.name" />
                </div>
                <div v-else>{{scope.row.createByUser.name}}</div>
              </template>
                </el-table-column>
                <el-table-column prop="createDate" label="操作时间" width="180">
                  <template slot-scope="scope">
                <div>{{scope.row.createDate.substring(0, 10)}}</div>
              </template>
                </el-table-column>
                <el-table-column prop="dele" label="操作">
                  <template slot-scope="scope">
                    <div style="text-align: center" v-if="!scope.row.id">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index)"
            >取消</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="addScore(scope.$index)"
            >确定</el-button>
          </div>
          <el-tooltip
                  effect="dark"
                  content="删除"
                  placement="top"
                  popper-class="texttooltip"
                    v-if="scope.row.id"
                >
                  <i class="iconfont icon-shanchu1 icon_btn" @click.stop="delScore(scope.$index, scope.row)" style="cursor: pointer;" />
                </el-tooltip>
              </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="info_subject" v-else style="align-items: center;justify-content: center;">
              <el-empty image="https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/stateImg/nodata_pc.png" :image-size="223" description="暂无数据" />
            </div>
      </template>
    </Dialogs>
    <!-- 视频预览组件 -->
    <VideoPreview
      :visible.sync="showVideo"
      :url="videoUrl"
      @update:visible="val => console.log('visible 更新为:', val)"
    />
  </div>
</template>

<script>
import {
  automgetAddBefore,
  meritsfindPre,
  meritsSave,
  updateDetailExtend,
  meritSubmit,
  exportMeritsDetail,
  ScoreSave,
  ScoreFindList,
  ScoreDelete
} from '../../../utils/api/kpiV2'
import { wxConfig } from '../../../utils/wxConfig'
import { delFile, initIsvDingSpace, addDingFile, initPreviewAuth, getShowAuthority } from '../../../utils/api/file'
import uploadAttachment from 'dingtalk-jsapi/api/biz/util/uploadAttachment' // 上传附件到钉盘/从钉盘选择文件
import preview from 'dingtalk-jsapi/api/biz/cspace/preview' // 预览文件
import { wpsOfficeConfig } from '../../../utils/wpsoffice/wpsOffice'
import multiUpload from '../../../components/common/upload/multiUpload'
import Dialogs from '../../../components/common/dialog.vue'
import VideoPreview from '../../../components/common/videoPreview/index.vue'
export default {
  components: { multiUpload, Dialogs, VideoPreview },
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    },
    currentType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      uploadType: JSON.parse(sessionStorage.getItem('loginUserData')).uploadType,
      headers: {
        sessiontoken: JSON.parse(sessionStorage.getItem('loginUserData')).sessionTokenId
      },
      detailInfos: {},
      tableData: [],
      tableHeaders: [],
      // 提交的信息
      extendEdit: {},
      rowspanNum: 1,
      // 当前index
      CurrentIndex: -1,
      fileList: [],
      fileData: {
        objectType: '',
        objectId: '',
        type: '20',
        source: 'oss',
        taskId: '',
        proId: '',
        versionId: ''
        // fileFormat: '',
        // fileName: '',
        // fileSize: ''
      },
      uploadBtn: 'performance',
      // 添加考核项弹框
      dialogModifiedScore: {
        addDounced: false, // 显示新增
        title: '总分调整明细',
        width: '80%',
        slotName: 'desc',
        // 分数
        scoreTableData: [],
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '调整', type: 'primary', fun: this.modifiedScore }
        ]
      },
      scoreValue: {
        remark: '',
        scoreType: [
          { id: '+', name: '加分' },
          { id: '-', name: '减分' }
        ],
        num: 0,
        type: ''
      },
      list_index: '',
      showVideo: false,
      videoUrl: ''
    }
  },
  watch: {
    detailInfo: {
      handler() {
        this.checkdetail()
      },
      deep: true
    },
    tableData: {
      deep: true,
      // 修改为普通函数以确保 this 指向组件实例
      handler: function() {
        this.$nextTick(() => {
          this.$refs.table.doLayout()
          setTimeout(() => {
            const dom = this.$refs['table'].bodyWrapper
            dom.addEventListener('scroll', () => {
              const scrollTop = dom.scrollTop// 滚动高度
              this.$refs['table'].$refs.fixedBodyWrapper.scrollTop = scrollTop
            })
          }, 0) // 建议添加延迟时间
        })
      }
    }
  },
  mounted() {
    this.checkdetail()
    if (this.channel === 'wechat') {
      wxConfig()
      setTimeout(() => {
        this.$forceUpdate()
        this.$refs.table.doLayout()
        this.ScoreFindList()
      }, 1000)
    } else {
      setTimeout(() => {
        this.$forceUpdate()
        this.$refs.table.doLayout()
        this.ScoreFindList()
      }, 1000)
    }
  },
  methods: {
    getScoreTypeLabel(info) {
      return info.scoreType === '1' ? '评分(分值)' : '评分(%)'
    },
    getScoreTypePlaceholder(info) {
      return info.scoreType === '1' ? '分值' : '百分比'
    },
    getFormattedValue(value) {
      // 检查 value 是否为字符串
      if (typeof value === 'string') {
        return value.replace(/\n/g, '<br>')
      }
      // 如果不是字符串，返回空字符串或其他默认值
      return value
    },
    getInputHeight(length) {
      if (length === 0) {
        return '90px'
      } else if (length === 1) {
        return '70px'
      } else {
        return '35px'
      }
    },
    getListtHeight(length) {
      if (length === 0) {
        return '0px'
      } else if (length === 1) {
        return '30px'
      } else if (length === 2) {
        return '54px'
      } else {
        return '60px'
      }
    },
    // 打开弹框
    changeScore(info) {
      this.dialogModifiedScore.addDounced = true
      this.dialogModifiedScore.num = undefined
      if (this.type === 'me' || this.type === 'fromme') {
        this.dialogModifiedScore.operatorList = [
          { label: '取消', type: '', fun: this.cancelDialog }
        ]
      } else if (this.type === 'examine ') {
        this.dialogModifiedScore.operatorList = [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '调整', type: 'primary', fun: this.modifiedScore }
        ]
      }
    },
    FinstandardChange(val) {
      this.dialogModifiedScore.desc = val
    },
    handleChange(value) {
      // 清空其他选项的选中状态 this.dialogModifiedScore.checkbox
      if (this.dialogModifiedScore.checkbox.length > 1) {
        this.dialogModifiedScore.checkbox.splice(0, 1)
      }
    },
    editScore(value) {
      this.dialogModifiedScore.num = value
    },
    // 添加分数确实
    modifiedScore() {
      if (this.dialogModifiedScore.scoreTableData.length > 0 && !this.dialogModifiedScore.scoreTableData[0].id) {
        this.$message.warning('请先完成上一条!')
        return
      }
      this.scoreValue = {
        remark: '',
        scoreType: [
          { id: '+', name: '加分' },
          { id: '-', name: '减分' }
        ],
        score: 0,
        id: '',
        createDate: this.getCurrentDateTime(),
        type: '+',
        createByUser: {
          userid: JSON.parse(sessionStorage.getItem('loginUserData')).userDingId,
          id: JSON.parse(sessionStorage.getItem('loginUserData')).userId,
          name: JSON.parse(sessionStorage.getItem('loginUserData')).userName,
          avatar: JSON.parse(sessionStorage.getItem('loginUserData')).userAvatar
        }
      }
      this.dialogModifiedScore.scoreTableData.unshift(this.scoreValue)
    },
    // 获取时间
    getCurrentDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      // const hours = String(now.getHours()).padStart(2, '0')
      // const minutes = String(now.getMinutes()).padStart(2, '0')
      // const seconds = String(now.getSeconds()).padStart(2, '0')

      return `${year}/${month}/${day}`
      // ${hours}:${minutes}:${seconds}
    },
    // 增减列表
    ScoreFindList() {
      var date = {
        meritsId: this.detailInfo.id
      }
      ScoreFindList(date).then((data) => {
        if (data.code === 10000) {
          this.dialogModifiedScore.scoreTableData = data.result
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 取消
    handleEdit(index, row) {
      this.dialogModifiedScore.scoreTableData.splice(index, 1)
    },
    // 添加分数确定
    addScore() {
      if (!this.scoreValue.num) {
        this.$message.warning('请输入分值')
        return
      }
      var date = {
        'meritsId': this.detailInfos.id,
        'type': this.scoreValue.type,
        'score': this.scoreValue.num,
        'content': this.scoreValue.content
      }
      ScoreSave(date).then((data) => {
        if (data.code === 10000) {
          // this.dialogModifiedScore.addDounced = false
          console.log(this.$parent, 'this.$parent')
          // this.$parent.checkdetail(this.detailInfos, this.currentType)
          this.ScoreFindList()
          this.$emit('checkdetail', this.detailInfos, this.currentType)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 删除分数
    delScore(index, row) {
      this.$confirm('此操作将删除该内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: row.id
        }
        ScoreDelete(date)
          .then((data) => {
            if (data.code === 10000) {
              this.dialogModifiedScore.scoreTableData.splice(index, 1)
              this.ScoreFindList()
            } else {
              this.$message.error(data.info)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 设置单元格class名
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const currentValue = row.typeName
        const previousValue = rowIndex > 0 ? this.tableData[rowIndex - 1].typeName : null

        // 仅为第一个可见单元格添加样式
        if (currentValue !== previousValue) {
          return 'merged-cell'
        }
      }
      if (this.detailInfos.status === '0') {
        return
      }
      // 为最后一个合并单元格添加样式
      const lastScoreIndex = this.tableHeaders.length + 3

      if (columnIndex === lastScoreIndex) {
        const currentValue = row.typeName
        const previousValue = rowIndex > 0 ? this.tableData[rowIndex - 1].typeName : null

        // 仅为第一个可见单元格添加样式
        if (currentValue !== previousValue) {
          return 'merged-cell-l'
        }
      }
      return ''
    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 处理第一列
        const currentValue = row.typeName
        const previousValue =
          rowIndex > 0 ? this.tableData[rowIndex - 1].typeName : null

        if (currentValue === previousValue) {
          return [0, 0] // 让当前单元格隐藏
        } else {
          let count = 1
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].typeName === currentValue) {
              count++
            } else {
              break
            }
          }
          return [count, 1] // 合并 count 行
        }
      }

      if (this.detailInfos.status === '0') {
        return
      }
      // 处理最后一行
      const lastScoreIndex = this.tableHeaders.length + 3
      if (columnIndex === lastScoreIndex) {
        // 只处理第一列
        const currentValue = row.typeName
        const previousValue =
          rowIndex > 0 ? this.tableData[rowIndex - 1].typeName : null

        if (currentValue === previousValue) {
          return [0, 0] // 让当前单元格隐藏
        } else {
          let count = 1
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].typeName === currentValue) {
              count++
            } else {
              break
            }
          }
          return [count, 1] // 合并 count 行
        }
      }
    },
    // 考评详情
    checkdetail() {
      this.detailInfos = this.detailInfo
      this.tableData = this.detailInfo.detailList
      if (this.detailInfo.itemList && this.detailInfo.itemList.length > 0) {
        if (this.channel === 'ding') {
          this.tableHeaders = this.detailInfo.itemList.map((item, index) => ({
            label: `${item.name}`,
            prop: `${item.key}`
          }))
        } else {
          this.detailInfo.itemList.map((element) => {
            var regex = /###([^#]+)###/g
            if (regex.test(element.name)) {
              element.name = element.name.replace(regex, "<ww-open-data type='userName' openid='$1'>$1</ww-open-data>")
            }
          })
          this.tableHeaders = this.detailInfo.itemList.map((item, index) => ({
            label: `${item.name}`,
            prop: `${item.key}`
          }))
        }
      }
    },
    checkdetail1() {
      var list = 'list'
      this.$emit('checkdetail1', list)
    },
    handleInput1(value, item) {
      // 去掉前导零（防止输入如 0001）
      item.extendEdit.flowScore = this.inputValue.replace(/^0+/, '')
      // 使用正则表达式替换掉所有非正整数的字符
      item.extendEdit.taskRealityScore = value.replace(/[^\d]/g, '')

      // 如果超过100, 截断为100
      if (Number(item.extendEdit.taskRealityScore) > 200) {
        item.extendEdit.taskRealityScore = '200'
      }
    },
    handleInput2(value, item) {
      // 使用正则表达式替换掉所有非正整数的字符
      item.extendEdit.flowScore = value.replace(/[^\d]/g, '')

      // 如果超过100, 截断为100
      if (Number(item.extendEdit.flowScore) > 200) {
        item.extendEdit.flowScore = '200'
      }
    },
    // 评分说明
    changeText(row, index) {
      this.extendEdit = row
      this.CurrentIndex = index
      var fileIds = []
      if (this.tableData[this.CurrentIndex].extendEdit.fileList && this.tableData[this.CurrentIndex].extendEdit.fileList.length > 0) {
        this.tableData[this.CurrentIndex].extendEdit.fileList.map((item) => {
          fileIds.push(item.id)
        })
      }
      var date = {
        id: row.extendEdit.id,
        flowScore: row.extendEdit.flowScore,
        remark: row.extendEdit.remark,
        fileIds: fileIds
      }
      updateDetailExtend(date)
        .then((data) => {
          if (data.code === 10000) {
            console.log(data)
          } else {
            this.$message.error(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 获取焦点
    handleFocus(row, index) {
      this.extendEdit = row
      this.CurrentIndex = index
    },
    // 提交修改
    submitInfo() {
      var date = {
        id: this.detailInfos.id
      }
      meritSubmit(date).then((data) => {
        if (data.code === 10000) {
          var list = 'list'
          this.$emit('checkdetail1', list)
        } else {
          this.$message.warning(data.info)
        }
      })
    },
    // 导出明细
    exportMeri() {
      var date = {
        id: this.detailInfos.id,
        searchType: this.type
      }
      exportMeritsDetail(date)
        .then((data) => {
          if (data.code === 10000) {
            this.$message.success('绩效详情导出中，请稍候在异步区查看文件')
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // 删除考核预览
    handleDelete(index, row) {
      if (row.type === '0') {
        this.$confirm('此操作将删除该任务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // var date = {
          //   taskId: row.taskId,
          //   taskType: row.taskType
          // }
          this.dialogInitiate.tableData.splice(index, 1)
        }).catch(() => {})
      } else {
        this.dialogInitiate.tableData.splice(index, 1)
      }
    },
    // 分类修改
    sortChange(val) {
      console.log(val)
    },
    // 完成标准修改
    standardChange(val) {
      console.log(val)
    },
    // 发起任务修改
    initiateChange(val) {
      console.log(val)
    },
    // 发起考核按钮
    initiate() {
      this.dialogExamine.date = ''
      this.dialogExamine.templateValue = ''
      this.dialogExamine.followValue = ''
      this.dialogExamine.userList = []
      this.dialogExamine.addDounced = true
      var meritsUserList = []
      if (
        this.dialogExamine.userList &&
        this.dialogExamine.userList.length > 0
      ) {
        this.dialogExamine.userList.map((item) => {
          meritsUserList.push({
            id: item.id
          })
        })
      } else {
        meritsUserList = [{ id: '' }]
      }
      var date = {
        meritsUserList: meritsUserList
      }
      automgetAddBefore(date)
        .then((data) => {
          if (data.code === 10000) {
            this.$nextTick(() => {
              this.dialogExamine.templateOptions = data.result.meritsTempList
              this.dialogExamine.followOptions = data.result.meritsFlowList
            })
          } else {
            this.$message.error(data.info)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 考核日期
    ExamineChange(e) {
      this.dialogExamine.date = e
    },
    // 评分模板修改
    templateChange(e) {
      this.$forceUpdate()
      this.dialogExamine.templatValue = e
    },
    // 评分流程修改
    followChange(e) {
      this.dialogExamine.followValue = e
    },
    // 发起考核下一步
    Examine() {
      if (this.dialogExamine.date === '') {
        this.$message.error('请选择考核日期')
        return
      } else if (this.dialogExamine.templatValue === '') {
        this.$message.error('请选择评分模板')
        return
      } else if (this.dialogExamine.userList.length === 0) {
        this.$message.error('请选择考核人员')
        return
      } else if (this.dialogExamine.followValue === '') {
        this.$message.error('请选择评分流程')
        return
      }
      var meritsUserList = []
      if (
        this.dialogExamine.userList &&
        this.dialogExamine.userList.length > 0
      ) {
        this.dialogExamine.userList.map((item) => {
          meritsUserList.push({
            id: item.id
          })
        })
      }
      var date = {
        meritsDate: this.dialogExamine.date,
        meritsUserList: meritsUserList,
        tempId: this.dialogExamine.templateValue,
        flowId: this.dialogExamine.followValue
      }
      meritsfindPre(date)
        .then((data) => {
          if (data.code === 10000) {
            this.dialogExamine.addDounced = false
            this.dialogInitiate.addDounced = true
            this.dialogInitiate.tableData = data.result
          } else {
            this.$message.error(data.info)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 发起考核确定
    addRoles() {
      this.dialogInitiate.addDounced = false
      var meritsUserList = []
      if (
        this.dialogExamine.userList &&
        this.dialogExamine.userList.length > 0
      ) {
        this.dialogExamine.userList.map((item) => {
          meritsUserList.push({
            id: item.id
          })
        })
      }
      var date = {
        meritsDate: this.dialogExamine.date,
        meritsUserList: meritsUserList,
        tempI: this.dialogExamine.templateValue,
        flowId: this.dialogExamine.followValue,
        detailList: this.dialogInitiate.tableData
      }
      meritsSave(date)
        .then((data) => {
          if (data.code === 10000) {
            this.getUserKPIList()
          } else {
            this.$message.error(data.info)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 文件上传之前的校验
    beforeUpload(file) {
      // this.$refs.upload.data.fileFormat = file.name.split('.').pop()
      // this.$refs.upload.data.fileName = file.name
      // this.$refs.upload.data.fileSize = file.size
      this.fileData.fileFormat = file.name.split('.').pop()
      this.fileData.fileName = file.name
      this.fileData.fileSize = file.size
      // this.$refs.upload.clearFiles()
    },
    // 文件上传成功
    successFile(response, file, fileList) {
      if (response.code === 10000) {
        this.tableData[this.CurrentIndex].extendEdit.fileList.push(response.result)
        this.changeText(this.tableData[this.CurrentIndex], this.CurrentIndex)
      } else {
        this.$message.warning(response.info)
      }
    },
    // 上传文件
    uploadFile() {
      var that = this
      var date = {
        authType: 'add',
        objectType: '',
        objectId: ''
      }
      initIsvDingSpace(date).then((res) => {
        uploadAttachment({
          file: {
            multiple: true,
            spaceId: res.result + '',
            max: 9
          },
          space: {
            corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
            spaceId: res.result + '',
            isCopy: 1,
            max: 9
          },
          image: {
            multiple: true,
            compress: true,
            max: 9,
            spaceId: res.result + ''
          },
          types: [
            'space',
            'file',
            'photo'], // PC端支持["photo","file","space"]
          onSuccess: function(result) {
            var list = []
            if (!result.data) {
              list = result || []
            } else {
              list = result.data || []
            }
            list.map((item) => {
              that.uploadFileLists(result.data, item)
            })
          },
          onFail: function(err) {
            console.log(err, 'err')
          }
        }).then((res) => {
          console.log('then______err', res)
        }).catch((err) => {
          console.log('catch______err', err)
        })
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 上传文件接口
    uploadFileLists(type, item) {
      var date1 = {}
      // 添加文件
      if (!type) {
        date1 = {
          objectType: '',
          objectId: '',
          type: '20',
          source: 'ding',
          absoUrl: item,
          taskId: '',
          proId: '',
          versionId: ''
        }
      } else {
        date1 = {
          objectType: '',
          objectId: '',
          type: '20',
          taskId: '',
          proId: '',
          versionId: '',
          source: 'ding',
          fileFormat: item.fileType,
          fileName: item.fileName,
          dingSpaceId: item.spaceId,
          dingFileId: item.fileId,
          fileSize: item.fileSize
        }
      }
      addDingFile(date1).then((res) => {
        if (res.code === 10000) {
          this.tableData[this.CurrentIndex].extendEdit.fileList.push(res.result)
          this.changeText(this.tableData[this.CurrentIndex], this.CurrentIndex)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '网络错误，请稍候！'
        })
      })
    },
    // 预览文件
    previewFile(item, index) {
      const fileIds = item.dingFileId
      const spaceId = item.dingSpaceId
      const fileId = item.dingFileId
      const fileName = item.fileName
      const fileSize = item.fileSize
      const fileType = item.fileFormat
      var date1 = {
        id: '',
        fileId: item.id
      }
      getShowAuthority(date1).then((data1) => {
        if (data1.code === 10000) {
          var date = {
            fileIds: fileIds
          }
          if (item.source === 'ding') {
            initPreviewAuth(date).then((data) => {
              if (data.code === 10000) {
                preview({
                  corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
                  spaceId: spaceId,
                  fileId: fileId,
                  fileName: fileName,
                  fileSize: fileSize,
                  fileType: fileType,
                  onSuccess: function(res) {
                    console.log(res, '')
                  },
                  onFail: function(err) {
                    console.log(err)
                  }
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          } else {
            var imgs = ['MP4', 'AVI', 'WMV', 'MKV', 'FLV', 'MPG', 'MPEG', 'M2V', 'M3U8', 'TS', 'MOV', 'WMV', 'RM', 'RMVB', 'ASF', 'VOB', 'DAT', 'DV', 'M4V', 'WEBM', 'OGG', '3GP', 'MPEG4',
              'mp4', 'avi', 'wmv', 'mkv', 'flv', 'mpg', 'mpeg', 'm2v', 'm3u8', 'ts', 'mov', 'wmv', 'rm', 'rmvb', 'asf', 'vob', 'dat', 'dv', 'm4v', 'webm', 'ogg', '3gp', 'mpeg'
            ]
            if (imgs.includes(item.fileFormat)) {
              this.showVideo = true
              this.videoUrl = item.absoUrl
            } else {
              wpsOfficeConfig(item)
            }
          }
        } else {
          this.$message.warning(data1.info)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 删除文件
    delFun(item, index, CurrentIndex) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: item.id
        }
        delFile(date).then((data) => {
          if (data.code === 10000) {
            this.tableData[CurrentIndex].extendEdit.fileList.splice(index, 1)
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    // 弹框关闭
    beforeClose() {
      this.dialogModifiedScore.addDounced = false
    },
    // 弹框取消
    cancelDialog() {
      this.dialogModifiedScore.addDounced = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/index.scss";
.mine {
  // margin: 0 24px;
  .mine_header {
    margin: 12px 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .mine_heade_line {
    display: inline-block;
    margin-right: 13px;
    width: 5px;
    height: 16px;
    background: $color_main;
    border-radius: 3px;
  }
}
::v-deep .table-score {
  .el-table__body-wrapper {
  overflow: auto;
  overflow-x: hidden;
}
}
// 详情样式
.list_header {
  display: flex;
  align-items: center;
  height: 60px;
  // background: antiquewhite;
  margin-bottom: 12px;
  justify-content: space-between;
  .list_header_ {
    cursor: pointer;
    text-align: left;
    margin-right: 55px;
  }
  .list_heade_line {
    font-size: 15px;
    color: #333333;
  }
}

/* //可设置胶囊宽高 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  // height: 10px;
  z-index: 9999999;
}
::v-deep .table-box .el-table__fixed {
  height: 100% !important;
}
::v-deep .table-box .el-table__fixed-right {
  height: 100% !important;
}
::v-deep .el-table .cell {
  height: auto !important;
  line-height: normal !important;
  padding: 10px !important;
  box-sizing: border-box;
}
::v-deep .el-table--border .el-table__cell {
  border-right: none;
}
::v-deep .merged-cell {
  border-right: 1px solid #EBEEF5 !important;
}
::v-deep .merged-cell-l {
  border-left: 1px solid #EBEEF5 !important;
}

::v-deep .el-textarea__inner {
  // height: 70px !important;
  padding: 3px 7px !important;
  height: 100%;
}
::v-deep .el-input__inner {
  height: 110px !important;
}
// 解决拖拽表格滚动条，错位问题
.el-table__header-wrapper{
  padding-right: 10px!important; // 滚动条宽度
}

::v-deep.el-table .el-table__fixed .el-table__fixed-body-wrapper .el-table__body {
      padding-bottom: 10px!important;
}
::v-deep.el-table .el-table__fixed-right .el-table__fixed-body-wrapper .el-table__body {
      padding-bottom: 10px!important;
}

.el-table__fixed-body-wrapper .el-table__body {
  padding-bottom: 10px!important; // 滚动条高度
}
.describe {
  width: calc(100% - 2px);
  border: 1px solid #E9E9EA;
  border-radius: 4px;
  height: 110px;
  position: relative;
}
.upload {
  // padding: 0 10px;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: #a8a8a8;
  // line-height: 36px;
  display: flex;
  justify-content: center;
  background: #eeeeee;
  margin-bottom: -5px;
  border-radius: 0 0 3px 3px;
  bottom: 5px;
    position: absolute;
    width: 100%;
    cursor: pointer;
  // pointer-events: none; // 禁⽌⿏标点击事件（放到事件上和鼠标样式冲突）
  // cursor: not-allowed; // 鼠标禁止样式
}
.uploadfile{
  height: 18px;
  line-height: 18px;
  cursor: pointer;
}
.uploadfile:hover{
  color: $color_main;
}
.file_icon{
  font-size: $font_18;
  margin-right: 2px;
  color: #838383;
}
  .file__icon {
    font-size:10px;
    color: #ffb83e;
    margin-right: 5px;
  }
.file_lists {
  width: 100%;
  // width: calc(100% - 10px);
  // max-height: 30px !important;
  padding: 0 5px;
  padding-bottom: 5px;
  font-size: $font_12;
  font-family: $font_family;
  font-weight: 400;
  color: #909090;
  line-height: 24px;
  position: absolute;
  bottom: 13px;
}
.release_btn {
  margin-bottom: 5px;
  ::v-deep .el-button {
    // width: 64px;
    height: 36px;
    background: #F5F5F5 !important;
    border-radius: 4px;
    font-size: $font_14;
    font-family: $font_family;
    font-weight: 400;
    color: $color_9;
    line-height: 12px;
    border-color: #F5F5F5 !important;
    text-align: center;
    cursor: pointer;
  }
}
.file_boxs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
}
.file_boxs:hover {
  background: #F4F4F4;
  border-radius: 2px;
  cursor: pointer;
}
.file_boxs:hover .del__icon {
  display: block;
}
.del__icon {
  font-size: $font_14;
  color: #9C9C9C;
  cursor: pointer;
  display: none;
}
.del__icon:hover {
  color: $color_main;
}
.desc-pick{
  line-height: 35px;
  border-color: #E9E9EA;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  padding: 0 10px;;
  border: 1px solid #909090;
}
/* 文本域默认样式 */
::v-deep .el-input__inner {
  line-height: 35px;
  border-color: #E9E9EA;
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  // padding: 0 10px;
  color: $color_2;
}
::v-deep .el-textarea__inner {
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  // padding: 0 10px;
  color: $color_2;
  border: none;
}
::v-deep .el-textarea .el-input__count {
  bottom: -26px;
  background: none;
  line-height: 15px;
}
.info_subject {
  display: flex;
  align-items: flex-start;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_6;
  line-height: 22px;
  margin: 18px 14px;
  .info_subject_option {
    display: flex;
    width: 100%;
  }
  .info_subject_option_title{
      width: 40px;
      margin-right: 16px;
      height: 32px;
      font-family: $font_family1;
      font-weight: 400;
      font-size: 15px;
      color: #666666;
      line-height: 31px;
      text-align: left;
      font-style: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    white-space: nowrap;
      cursor: pointer;
  }
  ::v-deep .el-textarea__inner {
    border: 1px solid #DCDFE6 !important;
    height: 80px !important;
    line-height: 35px;
}
}
.info_subject_option_content{
  display: flex;
  align-items: center;
    ::v-deep .el-input__inner {
    border: 1px solid #DCDFE6 !important;
    height: 40px !important;
}
::v-deep .el-input-number {
    position: relative;
    width: 372px !important;
}
}
::v-deep .el-table__append-wrapper{
    // overflow-y: auto !important;
    // height: 320px;
    .append_table{
      .el-table__body-wrapper {
      height: 320px !important;
      overflow-x: hidden !important;
    }
    }
  }
  ::v-deep .el-table__body-wrapper {
  .el-table__expanded-cell {
    z-index: 100;
    padding: 0;
  }
}
::v-deep .el-table__fixed,
::v-deep.el-table__fixed-right {
  .el-table__expanded-cell {
    visibility: hidden;
    padding: 0;
  }
}
  ::v-deep .is-leaf {
    height: 40px;
    color: #1b2e3b;
    background: #ebeef5;
  }
.info_subject {
  display: flex;
  align-items: flex-start;
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_6;
  line-height: 22px;
  margin: 18px 14px;
  ::v-deep .score_input{
  .el-textarea__inner{
    height: 38px !important;
    min-height: 35px !important;
    padding: 0 7px !important;
  }
  .el-input__inner{
    height: 35px !important;
  }
}
}

</style>
